export enum StatusResponse {
  Ok = "OK",
  Error = "ERROR",
}
